import { render, staticRenderFns } from "./RemoveItemDetails.vue?vue&type=template&id=598ff860&"
import script from "./RemoveItemDetails.vue?vue&type=script&lang=js&"
export * from "./RemoveItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports